import {
  yesNoSchema,
  yesNoUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-veteran-marriage-title']),
    marriedToVeteranAtTimeOfDeath: yesNoUI({
      title: content['household-veteran-marriage-question'],
    }),
  },
  schema: {
    type: 'object',
    required: ['marriedToVeteranAtTimeOfDeath'],
    properties: {
      marriedToVeteranAtTimeOfDeath: yesNoSchema,
    },
  },
};
